import { render } from "./SearchWidget.vue?vue&type=template&id=d8b7fb2e"
import script from "./SearchWidget.vue?vue&type=script&lang=js"
export * from "./SearchWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__